import { render, staticRenderFns } from "./SettingsExportConfig.vue?vue&type=template&id=4d735f69"
import script from "./SettingsExportConfig.vue?vue&type=script&lang=js"
export * from "./SettingsExportConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports